import {
  type paramsType,
  type returnType,
} from '~~/shared/api/rurality/v2/cottages/recommended/schema'

export default async (params: paramsType): Promise<returnType> => {
  const { $v2ApiNuxtEndpointPostPlugin } = useNuxtApp()

  const data = await $v2ApiNuxtEndpointPostPlugin(
    'rurality/v2/cottages/recommended',
    params,
  )

  return data as returnType
}
